module.exports = __webpack_public_path__ + "img/gywmn2.b3703449.png";